// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-RZpumi{flex-direction:column;flex:1;width:100%;margin-top:8px;display:flex}.message-wrapper-UOvJZw{flex-direction:column;max-width:100%;display:flex}.wrapper-last-HEajEZ{margin-top:4px}.wrapper-short-spacing-Q6aqV0{margin-top:4px;margin-bottom:4px}.wrapper-only-one-p0KowX{margin-top:8px}.wrapper-no-bottom-cmeLjx{margin-bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper-RZpumi`,
	"message-wrapper": `message-wrapper-UOvJZw`,
	"messageWrapper": `message-wrapper-UOvJZw`,
	"wrapper-last": `wrapper-last-HEajEZ`,
	"wrapperLast": `wrapper-last-HEajEZ`,
	"wrapper-short-spacing": `wrapper-short-spacing-Q6aqV0`,
	"wrapperShortSpacing": `wrapper-short-spacing-Q6aqV0`,
	"wrapper-only-one": `wrapper-only-one-p0KowX`,
	"wrapperOnlyOne": `wrapper-only-one-p0KowX`,
	"wrapper-no-bottom": `wrapper-no-bottom-cmeLjx`,
	"wrapperNoBottom": `wrapper-no-bottom-cmeLjx`
};
export default ___CSS_LOADER_EXPORT___;
